import gsap from 'gsap';

export default function fSubnav() {
    const oMainMenuItems = document.querySelectorAll('.header__main > .header__nav .header__nav__item');
    let oBackdrop;
    let fSubnavDelay;
    let nTransitioning = 0;

    const fCreateBackdrop = () => {
        oBackdrop = document.querySelector('.backdrop');

        if (!oBackdrop) {
            oBackdrop = document.createElement('div');
        }

        oBackdrop.classList.add('backdrop');
        document.body.appendChild(oBackdrop);
    }

    const fDestroyBackdrop = () => {
        if (nTransitioning < 2) {
            oBackdrop.remove();
        }

        nTransitioning -= 1;
    }

    const fOpenSubmenu = event => {
        let oMenuItem = event.target;
        let oSubMenu = oMenuItem.querySelector('.js-submenu');

        nTransitioning += 1;

        if (oSubMenu) {
            let tl = new gsap.timeline();
            let oSubmenuContent = oSubMenu.querySelector('.container');

            fCreateBackdrop();

            fSubnavDelay = setTimeout(() => {
                tl.timeScale(2.75);
                tl.set(oSubmenuContent, {
                    autoAlpha: 0
                }).to(oSubMenu, 1.2, {
                    ease: 'quart.Out',
                    scaleY: 1,
                    autoAlpha: 1
                }).to(oBackdrop, 1.5, {
                    ease: 'linear.None',
                    autoAlpha: 1
                }, 0).to(oSubmenuContent, .75, {
                    ease: 'linear.None',
                    autoAlpha: 1
                });
            }, 200);
        }
    }

    const fCloseSubmenu = event => {
        let oMenuItem = event.target;
        let oSubMenu = oMenuItem.querySelector('.js-submenu');

        if (oSubMenu && oBackdrop) {
            let tl = new gsap.timeline();
            let oSubmenuContent = oSubMenu.querySelector('.container');

            clearTimeout(fSubnavDelay);

            tl.timeScale(3000);
            tl.to(oSubmenuContent, .85, {
                autoAlpha: 0
            }).to(oBackdrop, 1, {
                autoAlpha: 0
            }).to(oSubMenu, .6, {
                ease: 'quart.InOut',
                autoAlpha: 0,
                scaleY: 0.5,
                onComplete: fDestroyBackdrop
            }, '-=1');
        }
    }

    const addMainMenuItemsListeners = (i) => {
        oMainMenuItems[i].addEventListener('mouseenter', event => {
            fOpenSubmenu(event);
        });

        oMainMenuItems[i].addEventListener('mouseleave', event => {
            fCloseSubmenu(event);
        });
    }

    for(let i = 0; i < oMainMenuItems.length; i += 1) {
        addMainMenuItemsListeners(i);
    }
}
